import React from 'react'
import DashboardPopup from 'modules/dashboard/DashboardPopup/DashboardPopup'
import styled from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'
import Selector from './Selector'
import Currency from 'components/UI/Currency'

export const Title = styled.div`
  color: ${colors.pink};
  font-size: 28px;
  text-align: center;
  margin-bottom: 15px;
`

export const Content = styled.div`
  display: flex;
  text-align: center;
  justify-content: space-between;
`

export const Option = styled.div`
  margin-top: 20px;
`

export const Price = styled.div`
  font-size: 30px;
  color: ${colors.darkPurple};
  margin: 8px 0 10px;
`

export const Label = styled.div`
  color: ${colors.pink};
`

const PLANS = [
  { nbStudents: '1-14', title: 'Small' },
  { nbStudents: '15-35', title: 'Medium' },
  { nbStudents: '35+', title: 'Large' }
]

export default class SelectPaymentPlanPopup extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    const { plans } = this.props
    if (!plans) {
      return null
    }
    const yearlyPlan = plans.filter(p => p.interval === 'year')[0]
    const monthlyPlan = plans.filter(p => p.interval === 'month')[0]
    return (
      <DashboardPopup onCancel={this.props.onCancel}>
        <Title>How would you like to pay?</Title>
        <Content>
          {plans
            .slice()
            .sort((x, y) => x.amount - y.amount)
            .map((p, i) => (
              <Option key={i} onClick={() => this.props.onSelect(p)}>
                <Button>{p.interval === 'month' ? 'Monthly' : 'Yearly'}</Button>
                <Price>
                  <Currency
                    amount={p.amount / 100}
                    currency={p.currency}
                  />
                </Price>
                {p.interval === 'year' && (
                  <Label>
                    Save{' '}
                    <Currency
                      amount={(monthlyPlan.amount * 12 - yearlyPlan.amount) / 100}
                      currency={monthlyPlan.currency}
                    />
                  </Label>
                )}
              </Option>
            ))}
        </Content>
      </DashboardPopup>
    )
  }
}
